import { jsx, jsxs } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { useEffect } from "react";
import { isDev, useSlotProps } from "../../../base/index.js";
import { Content } from "./components/Content.js";
import { Footer } from "./components/Footer.js";
import { Header } from "./components/Header.js";
import { LeftColumn } from "./components/LeftColumn.js";
import { RightColumn } from "./components/RightColumn.js";
import { Root } from "./components/Root.js";
import { loginLayoutName, useUtilityClasses } from "./classes.js";
const __DEV__ = isDev();
function PlaceholderComponent() {
  return /* @__PURE__ */ jsx("div", {});
}
function LoginLayout(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: loginLayoutName
  });
  const {
    sx,
    main,
    header,
    testId = "login-layout-root",
    className = "",
    secondary,
    mainFooter,
    components,
    hideSecondary,
    maxHeaderHeight = "none",
    componentsProps
  } = props;
  useEffect(() => {
    if (__DEV__) {
      if (!main) console.warn(`Main is required but wasn't provided!`);
      if (!secondary) console.warn(`Secondary is required but wasn't provided!`);
    }
  }, [main, secondary]);
  const ownerState = props;
  const utilityClasses = useUtilityClasses(ownerState);
  const rootSlotProps = useSlotProps({
    className: `${className} ${utilityClasses.root}`,
    ownerState,
    elementType: Root,
    additionalProps: {
      as: components?.Root,
      sx,
      "data-tidal": "LoginLayout",
      "data-testid": testId
    },
    externalSlotProps: componentsProps?.root
  });
  const leftColumnSlotProps = useSlotProps({
    className: utilityClasses.leftColumn,
    ownerState,
    elementType: LeftColumn,
    additionalProps: { as: components?.LeftColumn },
    externalSlotProps: componentsProps?.leftColumn
  });
  const contentSlotProps = useSlotProps({
    className: utilityClasses.content,
    ownerState,
    elementType: Content,
    additionalProps: { as: components?.Content },
    externalSlotProps: componentsProps?.content
  });
  const footerSlotProps = useSlotProps({
    className: utilityClasses.content,
    ownerState,
    elementType: Footer,
    additionalProps: { as: components?.Footer },
    externalSlotProps: componentsProps?.footer
  });
  const rightColumnSlotProps = useSlotProps({
    className: utilityClasses.rightColumn,
    ownerState,
    elementType: RightColumn,
    additionalProps: {
      as: components?.RightColumn,
      hide: hideSecondary
    },
    externalSlotProps: componentsProps?.rightColumn
  });
  const headerSlotProps = useSlotProps({
    className: utilityClasses.header,
    ownerState,
    elementType: Header,
    additionalProps: {
      as: components?.Header,
      maxHeight: typeof maxHeaderHeight === "string" ? maxHeaderHeight : `${maxHeaderHeight}px`
    },
    externalSlotProps: componentsProps?.header
  });
  return /* @__PURE__ */ jsxs(Root, { ...rootSlotProps, children: [
    /* @__PURE__ */ jsxs(LeftColumn, { ...leftColumnSlotProps, children: [
      /* @__PURE__ */ jsx(Content, { ...contentSlotProps, children: main || /* @__PURE__ */ jsx(PlaceholderComponent, {}) }),
      /* @__PURE__ */ jsx(Footer, { ...footerSlotProps, children: mainFooter })
    ] }),
    /* @__PURE__ */ jsx(RightColumn, { ...rightColumnSlotProps, children: secondary || /* @__PURE__ */ jsx(PlaceholderComponent, {}) }),
    header && /* @__PURE__ */ jsx(Header, { ...headerSlotProps, children: header })
  ] });
}
export {
  LoginLayout
};
//# sourceMappingURL=LoginLayout.js.map
